<template>
  <!--  <div>-->


  <b-form-group  label-for="user-name">
    <!--            <validation-provider-->
    <!--                #default="{ errors }"-->
    <!--                :name="fieldsData.name"-->
    <!--                :rules="fieldsData.required == 1 ? 'required' : ''">-->



<!--    />-->
<!--    <div>-->
      <label for="tags-basic" v-html="fieldsData.label[selectlang]"></label>
      <b-form-tags input-id="tags-basic"
                   :required="isRequired(fieldsData.required)"
                   :value="fieldsData.id"
                   :placeholder="fieldsData.id ==''?fieldsData.hint[selectlang]:''"
                   :type="fieldsData.inputType =='phone'?'number':fieldsData.inputType"
                   @input="UpdateValue($event)"
                   :tag-validator="tagValidator"
                   :pattern="fieldsData.pattern"
                   oninput="this.value = this.value.replace(/^0/, '');this.value = this.value.replace(/^[^6-9][0-9]*/, '');"
                   @keypress="(fieldsData.inputType === 'phone' || fieldsData.inputType === 'number') ? onlyNumber($event) : ''"

                   class="form-control"
      ></b-form-tags>

<!--    </div>-->


<!--    <small class="text-danger">{{ errors[0] }}</small>-->
    <!--            </validation-provider>-->
  </b-form-group>
  <!--  </div>-->
</template>

<script>
// import {ValidationProvider} from "vee-validate";
// import {required} from "@validations";
export default {
  components: {
    // ValidationProvider,
  },

  data() {
    return {

      // value: [],
      // required,
    };
  },
  props: ['fieldsData','selectlang'],



  created() {
    if (this.fieldsData.id) {
      // Split this.fieldsData.id into an array of integers
      this.fieldsData.id = this.fieldsData.id.split(',').map(item => parseInt(item.trim()));
    }

  },

  methods: {

    isRequired(requiredValue) {

      // Check if fieldsData.required is equal to 1
      return requiredValue == 1;
    },
    tagValidator(tag) {
      const regex = new RegExp(`^\\d{${this.fieldsData.maxLength}}$`);
      return regex.test(tag);
      // Individual tag validator function

      // return tag ===  tag.length > 2 && tag.length < 6
    },
    UpdateValue(value){
      // alert(value);
      // console.log(value);
      this.$emit('input',value)
    },



    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    formatterFunction(e) {

      return String(e).substring(0, this.fieldsData.maxLength);
    },



  }
}
</script>

<style>
/* Add your styles here */
</style>
